import * as PIXI from 'pixi.js';
import AssetsLoader from '../utils/assetsLoader';
import { APP_HEIGHT, MIDDLE_X_LOCATION, RESOLUTION } from '../utils/commonUtils';

const PLAYER_TYPES = {
    PLAYER: 'player',
    OPPONENT: 'opponent'
}

const players = {
    player: {
        x: MIDDLE_X_LOCATION,
        y: APP_HEIGHT,
        anchor: {
            x: 0.5,
            y: 1
        },
        background: 'PLAYER_BACKGROUND'
    },
    opponent: {
        x: MIDDLE_X_LOCATION,
        y: 0,
        anchor: {
            x:  0.5,
            y: 0
        },
        background: 'OPPONENT_BACKGROUND'
    }
}

export default class GameFieldContainer extends PIXI.Container {
    constructor(type = PLAYER_TYPES.PLAYER) {
        super()
        this.player = players[type];

        if(this.player) {
            const currentBackgroundAsset = type === PLAYER_TYPES.PLAYER ? 
            AssetsLoader.eDefaultAssetsAliases.PLAYER_BACKGROUND : 
            AssetsLoader.eDefaultAssetsAliases.OPPONENT_BACKGROUND;
            
            const backgroundTexture = PIXI.Assets.get(currentBackgroundAsset);
            const backgroundSprite = new PIXI.Sprite(backgroundTexture);

            this.x = this.player.x;
            this.y = this.player.y;
            this.label = `${type}-field`;

            backgroundSprite.anchor.set(this.player.anchor.x, this.player.anchor.y);
            backgroundSprite.scale.set(RESOLUTION);
            
            this.addChild(backgroundSprite);
        }
    }
} 